import { CategoryModel } from 'store/eligibility/documents/actions';

export default interface UploadDocumentModalProps {
  isUploadDocumentModalVisibleHandler(command: string, documentId: number[][]): any;
  getCategory(model: CategoryModel): any;
  uploadFilestoAuth(options: Object): any;
  eligibilityMemberInfo: any;
  isUploadDocumentModalVisible: boolean;
  isUploading: boolean;
  claimDos: string;
  setClaimDos(date: string): any;
  uploadMultipleCategories: boolean;
  allowMultipleAttachments: boolean;
};

export enum DocumentCategory {
  POSITIVE_NEGATIVE = 'positiveNegative',
  DOS = 'dos',
  MEASURE_YEAR = 'measureYear',
  TAGS = 'tags',
  SCORE = 'score',
  CATEGORY = 'category',
  FRACTURE_DATE = 'factureDate',
};

export interface MemberDocument {
  categoryDescription: string;
  category: string;
  tags: string;
  score: string;
  dos: string;
  fractureDate: string;
  positiveNegative: string;
  measureCode: string;
  measureGroup: string;
  measureGroupItem: string;
  measureYear: string;
  memberFile: any[];
  showScore: boolean;
  showDos: boolean;
  showFractureDate: boolean;
  showPositiveNegative: boolean;
};

export interface DocumentCategoryItem {
  "RmiUid": number;
  "RmiCategoryCode": string;
  "RmiCategoryDesc": string;
  "RmiCreatedBy": string | null;
  "RmiCreatedDate": string;
  "RmiModifiedBy": string | null;
  "RmiModifiedDate": string;
  "RmiMeasureGroup": string;
  "RmiMeasureCode": string;
  "RmiAgeStart": number | null;
  "RmiAgeEnd": number | null;
  "RmiAgeRange": string | null;
  "RmiMeasureGroupItem": string | null;
  "RmiShowDos": boolean | null;
  "RmiShowPositiveNegative": boolean | null;
  "RmiShowScore": boolean | null;
  "RmiShowFractureDate": boolean | null;
};
